import outdent from "outdent";
import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mosyle = defineConnector({
  identifier: "mosyle",
  name: "Mosyle",
  tagLine: "Apple device management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://businessapi\\.mosyle\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://businessapi.mosyle.com/v1/login",
        headers: [
          {
            name: "accesstoken",
            value: app.secret.accessToken,
          },
        ],
        jsonBody: {
          email: app.secret.email,
          password: app.secret.password,
        },
      },
      extract: { from: "header", name: "authorization" },
      apply: { kind: "header" },
    }),
  steps: [
    {
      title: "Enable the API integration",
      items: [
        {
          kind: "markdown",
          content: outdent`
            1. In the [Mosyle Business](https://business.mosyle.com) console, go to **Organization > Integrations > Mosyle API Integration**
            2. Click **Add new token** and generate a JWT API token
            3. Copy the token (it is shown only once)
          `,
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API token (JWT)",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
          helperText: "The JWT API token from your Mosyle console.",
        },
        {
          kind: "input",
          label: "Admin email",
          required: true,
          target: { kind: "secrets", field: "email" },
          helperText:
            "The email address of an admin account used to authenticate API sessions.",
        },
        {
          kind: "input",
          label: "Admin password",
          required: true,
          target: { kind: "secrets", field: "password" },
          helperText: "The password for the admin account above.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://businessapi.mosyle.com/v1/devices",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        operation: "list",
        options: { os: "mac", page: 1 },
      }),
      expectedStatus: [200, 403],
    }),
  },
});
